import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Stepper, Error } from '../../../components';
import { policySteps } from '../../../config/enums';
import { PhoneNumberField, InsuranceProviders } from '../components';
import { isOnline } from '../../../helpers';

export default function StepEight(props) {
    const { t } = useTranslation();
    const activeStep = 8
    const [invalidRoute, setsetInvalidRoute] = useState(null)
    const [insuranceType, setInsuranceType] = useState(null)
    const handleClickNext = () => {
        props.history.push({ pathname: `/${props.location.state?.insurance_type}/loading-packages`, state: { insurance_type: props.location.state.insurance_type }, search: props.location.search })
    }
    useEffect(() => {
        if (props.location.state?.insurance_type !== props.match.params?.type) {
            setsetInvalidRoute(true)
        }
        else {
            setInsuranceType(props.location.state?.insurance_type)
        }
    }, []);// eslint-disable-line react-hooks/exhaustive-deps

    return (
        <div className="container" id="page-wrapper">
            {!isOnline() ?
                <Error message={t("connection_error_message")} btnText={t("try_again_text")} onClick={() => window.location.reload()} /> :
                invalidRoute ? <Error message={t("invalid_path_message")} btnText={t("home_btn")} autoRedirect /> :
                    <div className="step pl-15 pr-15 wrapper">
                        <div className="head-wrapper">
                            <div>
                                <Stepper activeStep={activeStep} numOfSteps={policySteps[insuranceType]} />
                            </div>
                        </div>
                        <PhoneNumberField handleClickNext={handleClickNext} title={t("Can_you_share_your")} />
                        <InsuranceProviders type={props.match.params?.type} />
                    </div>
            }
        </div>
    )
}
